import { withVersions } from "v2/hocs/withVersions";
import withFooterNav from "../hocs/withFooterNav";
import FooterV1 from "./Footer/v1";
import FooterV2 from "./Footer/v2";

const Footer = withVersions({
  v1: withFooterNav(FooterV1 as any),
  v2: withFooterNav(FooterV2 as any),
});

export default Footer;
